import styled, { display, propTypes } from '@style'

const Br = styled.br`
  /* stylelint-disable */
  ${display}
`

Br.displayName = `Br`

Br.defaultProps = {
  display: `block`,
}

Br.propTypes = {
  ...propTypes.display,
}

export default Br
